import React from "react";

import { Hero } from "@/components/Hero";
import { billboardProps } from "@/data/types/home";
import { semHomeThemeAsset } from "@/utils/cdn";
import { Banner } from "../Banner";

export const HeroModule = ({ data }: { data: billboardProps }) => {
  const { ctaLabel, ctaLink, richtext, data_qa, ctaStyle, twoColumns } = data;

  return (
    <Banner
      light
      withoutPadding
      customBgColor={"neutral-white"}
      customClass="hero-module"
      data-testid="hero-module"
    >
      <Hero
        priority
        heroText={richtext}
        cta={{
          ctaLink,
          ctaLabel,
          data_qa,
          ctaStyle,
        }}
        twoColumns={twoColumns}
        img={semHomeThemeAsset("hero-banner.png")}
        size="(max-width: 480px) 256px, (max-width: 768px) 360px, 50vw"
        quality={65}
      />
    </Banner>
  );
};
